import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Layout from "../components/Layout";

export default function MinSkaperside() {
  const { user } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (user === false) { nav("/?tab=login"); return; }
    if (user && user.username) {
      if (user.is_creator) nav(`/skaper/${user.username}`, { replace: true });
      else nav("/bli-skaper", { replace: true });
    }
  }, [user, nav]);
  return <Layout><div className="text-center text-[var(--cream-soft)] py-20">Henter…</div></Layout>;
}
